import { render, staticRenderFns } from "./illumination.vue?vue&type=template&id=25e47c2c&scoped=true&"
import script from "./illumination.vue?vue&type=script&lang=js&"
export * from "./illumination.vue?vue&type=script&lang=js&"
import style0 from "./illumination.vue?vue&type=style&index=0&id=25e47c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e47c2c",
  null
  
)

export default component.exports